import { getPlatform, loadqwebchannel } from "./utils/Api.utils";
import { MessageUtil, FROM_TYPE} from "./utils/Message.util";
import {getQueryVariable} from 'Utils/utils'
import cuid from 'cuid'
//'use strict';
// let cuid = require("cuid");
// let Promise = require('es6-promise-promise');
// let scriptLoad = require('script-load');
// let asyncCall = false;
// let platform = getPlatform();

class PluginApiAdapter {

  constructor() {
    const {platform, asyncCall} = getPlatform();
    this.platform = platform;
    this.asyncCall = asyncCall;
    this.fnMap = {};
    this.windowMessageUtil = null;// new MessageUtil();
    this.callFunction = this.callFunction.bind(this);
    this.onRequestCallback = this.onRequestCallback.bind(this);
    this.handleOnlineFn = this.handleOnlineFn.bind(this);
    this.handlePhantomFn = this.handlePhantomFn.bind(this);
    this.handleMacFn = this.handleMacFn.bind(this);
    this.onHandleResult = this.onHandleResult.bind(this);
    this.init = this.init.bind(this);

    this.init()
  }
  init(){
    let origin = getQueryVariable('origin');
    let isDebug = getQueryVariable('debug');
    this.isDebug = isDebug;
    if(origin){
      this.windowMessageUtil = new MessageUtil(isDebug);
      this.windowMessageUtil.init(this.onRequestCallback, FROM_TYPE.TEMPLATE_PLUGIN, origin)
    }
  }
  onRequestCallback(method, data, id){
    return new Promise((resolve)=>{
      const fn = this.fnMap[method];
      fn && fn({method, data, id, resolve});
    })
  }
  handleOnlineFn(method, data, onEvent){
    // console.log('handleOnlineFn method:' + method, data)
    return this.windowMessageUtil.handleMessage(method, data, onEvent)
  }
  getPlatform = () => {
    return this.platform;
  }

  handlePhantomFn(args, method, onEvent){
    !!this.isDebug && console.log('start handlePhantomFnn: ', {args, method, time: Date.now()});
    return new Promise( (resolve) => {
      let args2 = args[2];
      typeof(args2) === 'object' && (args2 = JSON.stringify(args[2]))
      // let szResult = window.external.DispatchFun(args[0], args[1], args2);
      let szResult;
      if (window.isFoxitWebview) {
        const callbackName = 'dispatchFun3Callback';
        window[callbackName] = (szResult) => {
          !!this.isDebug && console.log('end handlePhantomFnn: ', {result: szResult, time: Date.now()});
          this.onHandleResult(szResult, method, resolve, onEvent);
        };
        chrome.webview.hostObjects.sync.FxWebView.DispatchFun3(args[0], args[1], args2, callbackName);
      } else {
        szResult = window.external.DispatchFun(args[0], args[1], args2);
        !!this.isDebug && console.log('end handlePhantomFnn: ', {result: szResult, time: Date.now()});
        this.onHandleResult(szResult, method, resolve, onEvent);
      }
    });
  }
  handleMacFn(args, method, onEvent){
    !!this.isDebug && console.log('start handleMacFn: ', {args, method, time: Date.now()});
    let _this = this;
    return new Promise( (resolve) => {
      let args2 = args[2];
      typeof(args2) === 'object' && (args2 = JSON.stringify(args[2]))
      if (this.asyncCall) {
        if (window.external) {
          window.external.DispatchFun(args[0], args[1], args2, function (result) {
            !!_this.isDebug && console.log('end handleMacFn-1: ', {result: result, time: Date.now()});
            _this.onHandleResult(result, method, resolve, onEvent);
            //resolve(result);
          });
        } else {
          loadqwebchannel( () => {
            window.external.DispatchFun(args[0], args[1], args2, function (result) {
              !!_this.isDebug && console.log('end handleMacFn-2: ', {result: result, time: Date.now()});
              _this.onHandleResult(result, method, resolve, onEvent);
            });
          });
        }
      } else if (window.webkit && window.webkit.messageHandlers && 
        window.webkit.messageHandlers.DispatchFunAsync && window.webkit.messageHandlers.DispatchFunAsync.postMessage) {
        var payload = {
            Module: args[0],
            FuncName: args[1],
            Params: args[2]
          };
        let result = window.prompt('__DispatchFun__', JSON.stringify(payload));
        _this.onHandleResult(result, method, resolve, onEvent);
      } else {
        let result = window.external.DispatchFun(args[0], args[1], args2);
        !!_this.isDebug && console.log('end handleMacFn-3: ', {result: result, time: Date.now()});
        _this.onHandleResult(result, method, resolve, onEvent);
      }
    });
  }
  onHandleResult(szResult, method, resolve, onEvent){
    !!this.isDebug && method !== "getFileStream" && console.log('DispatchFun return result:', szResult)
    let handle = setTimeout( () => {
      clearTimeout(handle);
      if(!szResult){
        console.error('callFunction method:'+ method +'\nDispatchFun return Null: ');
        resolve({ret:999});
        return;
      }
      let result;
      try {
        result = (typeof szResult === 'string') ? JSON.parse(szResult) : szResult;
      } catch (error) {
        console.error('callFunction method:'+ method +'\nDispatchFun return Wrong data format: '  + '\n'+ szResult);
        resolve({ret:999});
        return;
      }
      if(onEvent){
        onEvent(result);
        return;
      }
      resolve(result);
    }, 0);
  }

  callFunction (module, method, data, onEvent){ 
    //let args = Array.prototype.slice.call(arguments, 0);
    let args = [module, method, data];
    // let _this = this;
    !!this.isDebug && console.log('callFunction begin: method ' + method + ', data:' + JSON.stringify(data))
    // console.log("this.platform----", this.platform)

    let args_0 = JSON.stringify(args[0])          
    let args_1 = JSON.stringify(args[1])          
    let args_2 = JSON.stringify(args[2])  
    try {
      switch (this.platform) {
        case 'PhantomOnline': {
          //console.log("PluginApiAdapter -> callFunction -> args[0], args[1], args[2]", args[0], args[1], args[2])
          return this.handleOnlineFn(args[1], args[2], onEvent)
        }
        case 'FoxitReader':
        case 'Phantom': {
          return this.handlePhantomFn(args, method, onEvent)
        }
        case 'MacReader':
        case 'MacPhantom':
        case 'Lite': {
          return this.handleMacFn(args, method, onEvent);
        }
        case 'IOS': {
          return new Promise( (resolve) => {
            if (this.asyncCall) {
              let id = cuid();
              window[id] = function (resultValue) {
                resolve(resultValue);
                delete window[id];
              };
              try{
                window.webkit.messageHandlers.DispatchFun.postMessage([args_0, args_1, args_2, id]);
              }
              catch(err){
                console.log(err)
                resolve(err)
              }
            } else {
              try{
                let result = window.external.DispatchFun(args[0], args[1], args_2);
                this.onHandleResult(result, method, resolve, onEvent);
  
              }catch(err){
                console.log(err)
                resolve(err)

              }
             
            }
          });
        }
        case 'Android': {
          return new Promise( (resolve) => {
            try{
              let result = window.external.DispatchFun(args[0], args[1], args_2);
              this.onHandleResult(result, method, resolve, onEvent);
            }catch(err){
              resolve(err)
            }
          
          });
        }
  
        case 'platformSeven': {
          return new Promise( (resolve,/* reject */) => {
            //let modulename = args.shift();
            let fname = args.shift();
            // if (fname == "expandPanel" || fname == "isPanelActivate") {
            // 	let fn = parent.fnlist[window.name][fname].bind(null, window.name);
            // 	return fn(args);
            // }
             try {
                resolve(parent.fnlist[window.name][fname](args[0]));
             } catch (e) {
              resolve({ret:999})
                console.error(e, fname);
             }
            // }
            
          });
        }
        default: {
          return new Promise((resolve)=>{
            resolve({ret:999})
          })
          //throw 'unknow platform' + this.platform;
        }
      }
    } catch (error) {
      //console.log('callFunction try catch error')
    }
   

  }
}

export {
  PluginApiAdapter
};
// let PluginJS = {
//   getPlatform:  () => {
//     return platform;
//   },
//   ,
// };

// module.exports = PluginJS;


